import React, { PropTypes } from 'react';
import ReactDOM             from 'react-dom';
import Reflux               from 'reflux';
import $                    from 'jquery';
import PreviousIcon         from 'grommet/components/icons/base/Previous';
import NextIcon             from 'grommet/components/icons/base/Next';
import UpIcon               from 'grommet/components/icons/base/Up';
import DownIcon             from 'grommet/components/icons/base/Down';
import cx                   from 'classnames';
import Utils                from 'medscape/utils';
import Slider               from 'react-slick';
import VideoItem            from './video-item';

export default class Playlist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      index: props.carousel.initialSlide,
      playIndex: props.carousel.initialSlide,
      ended: false
    };
    this.amp = null;
  }
  componentDidMount() {
    window.playlist = this.refs.slider;
  }
  componentWillUnmount() {
    window.playlist = null;
    if(this.amp!=null){
      let mediaElement = this.amp.getMediaElement();
      $(mediaElement).off('ended.playlist');
      $(mediaElement).off('playing.playlist');
      this.amp = null;
    }
  }
  componentWillUpdate(nextProps, nextState) {
    if(nextProps.ready === true) {
      this.amp = nextProps.amp;
      let mediaElement = this.amp.getMediaElement();
      $(mediaElement).off('ended.playlist').on('ended.playlist', ()=> {
        this.doWatched();
      });
      $(mediaElement).off('playing.playlist').on('playing.playlist', ()=> {
        if(this.state.ended) {
          this.setState({
            ended: false
          });
        }
      });
    }
  }
  componentDidUpdate(prevProps,prevState) {
    let slideTo = this.state.playIndex - this.props.carousel.slidesToShow + 1;
    if( this.state.playIndex < this.state.index || this.state.playIndex > (this.state.index+this.props.carousel.slidesToShow-1)){
      this.refs.slider.slickGoTo(slideTo);
    }
  }
  doAfterChange(index) {
    this.state.index = index;
  }
  doBeforeChange(currIndex,nextIndex) {
  }
  doWatched() {

    let nextIndex = 0;
    for(let i=0; i<this.props.videos.length; i++) {
      if(this.props.videos[i]["video-config-id"]==this.props.video["config-id"]) {
        nextIndex=i+1;
        this.props.videos[i].watched = true;
        break;
      }
    }

    if(nextIndex<this.props.videos.length) {
      let nextVideo = this.props.videos[nextIndex];
      this.props.onChangeVideo(nextVideo["video-config-id"]);
    } else {
      this.setState({
          ended: true
      });
    }
  }
  getSlides() {
    let slides = this.props.videos.map( (video,index)=>{
      const key = `playlist-slide-${video["video-config-id"]}`;
      video.playing = !this.state.ended && (this.props.video["config-id"] == video["video-config-id"]);
      if(video.playing) {
        this.state.playIndex = index;
      }
      return (
        <div key={key} className="playlist-slider-item">
          <VideoItem {...video} onClick={ this.props.onChangeVideo}/>
        </div>
      );
    })
    return slides;
  }
  isVertical() {
    let isVertical = this.props.carousel.vertical;
    if(this.refs.slider && this.refs.slider.state.breakpoint!=null) {
      let slider = this.refs.slider;
      let breakpoint = this.props.carousel.responsive.find( (responsive)=>{
        return responsive.breakpoint == slider.state.breakpoint
      });
      if(breakpoint!=null && breakpoint.settings.vertical != null){
        isVertical = breakpoint.settings.vertical;
      }
    }
    return isVertical;
  }
  render() {
    let Settings = {
      ref: 'slider',
      prevArrow: (<PrevArrow isVertical={this.isVertical.bind(this)} />),
      nextArrow: (<NextArrow isVertical={this.isVertical.bind(this)} />),
      afterChange: this.doAfterChange.bind(this),
      beforeChange: this.doBeforeChange.bind(this)
    }
    let slider = $.extend({},Settings,this.props.carousel);
    return (
      <div className="playlist-component">
        <Slider {...slider}>
          { this.getSlides() }
        </Slider>

      </div>
    );
  }
}

Playlist.propTypes={
  "video": PropTypes.object,
  "videos": PropTypes.array,
  "carousel": PropTypes.object,
  "onChangeVideo": PropTypes.func,
  "amp": PropTypes.object
};
Playlist.defaultProps={
  "videos": [],
  "carousel": {},
  "onChangeVideo": ()=>{},
  "amp": null
};

class PrevArrow extends React.Component {
  render() {
    const classNames = cx({
      'carousel-arrow': true,
      'previous-button': true
    })
    let buttonProps = {
      className: classNames +' ' + this.props.className,
      onClick: this.props.onClick,
      title: "Previous"
    }
    if(this.props.isVertical()) {
      return (
        <button {...buttonProps}>
          <span className="icon-container"><UpIcon /></span>
        </button>
      ) ;
    }
    return (
      <button {...buttonProps}>
        <span className="icon-container"><PreviousIcon /></span>
      </button>
    );
  }
}
PrevArrow.propTypes={
  "isVertical": PropTypes.func
};
PrevArrow.defaultProps={
  "isVertical": ()=>{ return false; }
};

class NextArrow extends React.Component {
  render() {
    const classNames = cx({
      'carousel-arrow': true,
      'next-button': true
    });
    let buttonProps = {
      className: classNames +' ' + this.props.className,
      onClick: this.props.onClick,
      title: "Next"
    };
    if(this.props.isVertical()){
      return (
        <button {...buttonProps}>
          <span className="icon-container"><DownIcon /></span>
        </button>
      );
    }
    return (
      <button {...buttonProps}>
        <span className="icon-container"><NextIcon /></span>
      </button>
    );
  }
}
NextArrow.propTypes={
  "isVertical": PropTypes.func
};
NextArrow.defaultProps={
  "isVertical": ()=>{ return false; }
};



// WEBPACK FOOTER //
// ./medscape_modules/video/playlist/playlist.jsx